import { createAsyncThunk } from "@reduxjs/toolkit";

import homeService from "services/home";

export const fetchExpertCountries = createAsyncThunk(
  "get/expertCountries",
  async (_, { rejectWithValue, dispatch }) => {
    try {
      const response = await homeService.fetchExpertCountries();
      return response.data?.data;
    } catch (error: any) {
      return rejectWithValue(error);
    }
  }
);

export const fetchExpertCountriesFlat = createAsyncThunk(
  "get/expertCountriesFlat",
  async (_, { rejectWithValue, dispatch }) => {
    try {
      const response = await homeService.fetchExpertCountriesFlat();
      return response.data?.data;
    } catch (error: any) {
      return rejectWithValue(error);
    }
  }
);

export const fetchFamousExperts = createAsyncThunk(
  "get/famousExperts",
  async (_, { rejectWithValue, dispatch }) => {
    try {
      const response = await homeService.fetchFamousExperts();

      return response.data?.data;
    } catch (error: any) {
      return rejectWithValue(error);
    }
  }
);
export const fetchNewComerExperts = createAsyncThunk(
  "get/fetchNewComerExperts",
  async (_, { rejectWithValue, dispatch }) => {
    try {
      const response = await homeService.fetchNewComerExperts();
      return response.data?.data;
    } catch (error: any) {
      return rejectWithValue(error);
    }
  }
);
export const fetchTotalExpertCount = createAsyncThunk(
  "get/fetchTotalExpertCount",
  async (_, { rejectWithValue, dispatch }) => {
    try {
      const response = await homeService.fetchExpertCount();
      return response.data?.expert_count;
    } catch (error: any) {
      return rejectWithValue(error);
    }
  }
);

export const fetchHomePageTeachers = createAsyncThunk(
  "get/top/teachers",
  async (auth: boolean, { rejectWithValue }) => {
    try {
      const response = await homeService.fetchHomePageTeachers(auth);
      return response;
    } catch (error: any) {
      return rejectWithValue(error);
    }
  }
);

export const fetchHomePageLessonsByTags = createAsyncThunk(
  "get/top/lessons",
  async (tag: string, { rejectWithValue }) => {
    try {
      const response = await homeService.fetchHomePageLessonsByTags(tag);
      return response;
    } catch (error: any) {
      return rejectWithValue(error);
    }
  }
);

export const fetchHomePagePopularLessons = createAsyncThunk(
  "get/top/lessons/bytags",
  async (auth: boolean, { rejectWithValue }) => {
    try {
      const response = await homeService.fetchHomePagePopularLessons();
      return response;
    } catch (error: any) {
      return rejectWithValue(error);
    }
  }
);

export const setFavouriteLesson = createAsyncThunk(
  "set/favourite/lessons",
  async (data: any, { rejectWithValue, dispatch }) => {
    try {
      const response = await homeService.setFavouriteLesson(data.id);
      if (response) {
        if (data?.callback) data?.callback();
        else {
          await dispatch(fetchHomePagePopularLessons(true));
          await dispatch(fetchHomePageLessonsByTags(""));
        }
      }
      return response;
    } catch (error: any) {
      return rejectWithValue(error);
    }
  }
);

export const setBookmarkTeacher = createAsyncThunk(
  "set/bookmark/teacher",
  async (data: any, { rejectWithValue }) => {
    try {
      const response = await homeService.setBookmarkTeacher(data?.id);
      if (response && data?.callback) await data?.callback();
      return response;
    } catch (error: any) {
      return rejectWithValue(error);
    }
  }
);

// export const getLessonsTags = createAsyncThunk(
//   "get/lessons/tags",
//   async (_, { rejectWithValue, dispatch }) => {
//     try {
//       const response = await homeService.getLessonsTags();
//       return response;
//     } catch (error: any) {
//       return rejectWithValue(error);
//     }
//   }
// );

export const setTeacherRating = createAsyncThunk(
  "set/teacher/rating",
  async (data: any, { rejectWithValue, dispatch }) => {
    try {
      const response = await homeService.setTeacherRating(data);
      return response;
    } catch (error: any) {
      return rejectWithValue(error);
    }
  }
);
